import React, { useEffect, useRef, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, FormControl, InputGroup } from "react-bootstrap";
import { Line, Bar, Pie } from "react-chartjs-2";

import { Chart, registerables } from "chart.js";
import "./dashboard.css";
import { useNavigate } from "react-router-dom";

import {
  getcollegeApi,
  getcompanyTotalCount_API,
 getcommunTotalCount_API,
 getNewUpdates_cc_API,
  getdepartmentApi,
get_department_info_API,

  getAptitudeTotalCount_API,
  getTechnicalTotalCount_API,
  getRequestCount_CC_API,
  getAvgAptitude_cc_API,
  getAvgCoding_cc_API,
  getClgTopper_MCQ_CC_API,
  getOfferChart_cc_API,
  getUpcomingInterview_cc_API,
  getOfferStatus_cc_API,
  getUniqueCmpy_cc_API,
  getUniqueCmpy_Count_cc_API,
  getClgRegistered_API,
  getJobOffer_Count_CC_API,
  getClgTotal_IT_Count_API,
  getClgTotal_Core_Count_API
} from "../../api/endpoints";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
Chart.register(...registerables);

const Dashboard = ({ institute, username }) => {
  const [departments, setDepartments] = useState([]);
  const [totalComapnyCount, setTotalCompanyCount] = useState(null);
  const [collegeId, setCollegeID] = useState(institute);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [avgAptitudeScore, setAvgAptitudeScore] = useState([]);
  const [avgCodingScore, setAvgCodingScore] = useState([]);
  const [clgTopper, setClgTopper] = useState([]);
  const [selectedOptionClgTop, setSelectedOptionClgTop] = useState("MCQ Test");
  const [clgTopperCode, setClgTopperCode] = useState([]);
  const [upcomming, setUpcomming] = useState([]);
  const [offerStatus, setOfferStatus] = useState([]);
  const [college, setCollege] = useState([]);
  const [assessmentData1, setAssessmentData1] = useState([]);
  const [totalRequest, setTotalRequest] = useState(null);
  const [department, setDepartment] = useState([]);
  const [deptID, setDeptID] = useState("");
  const [companies, setCompanies] = useState([]);
  const [cmpyID, setCmpyID] = useState("");

  const [totalAptitudeCount, setTotalAptitudeCount] = useState(null);
  const [totalTechnicalCount, setTotalTechicalCount] = useState(null);
  const [trainerDetails, setTrainerDetails] = useState([]);
  const [testDetails, setTestDetails] = useState([]);
  const [announcements, setAnnouncements] = useState([]); // Define announcements state
  const [role, setRole] = useState("Training admin");
  const [Registered, setRegistered] = useState(0);
  const [totOffers, setTotOffers] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexPlace, setCurrentIndexPlace] = useState(0);
  const [announcementsPlace, setAnnouncementsPlace] = useState([]);
  const [totalPresent, setTotalPresent] = useState("");
  const [totalAbsent, setTotalAbsent] = useState("");
  const [chartType, setChartType] = useState("Line");
  const [chartTypePlace, setChartTypePlace] = useState("Line");
  const [totalcmpyCount, setTotalcmpyCount] = useState(null);
  const [totalcommunCount, setTotalcommunCount] = useState(null);

  const [triggerFetch, setTriggerFetch] = useState(true);
  const [it, setIT] = useState(0);
  const [core, setCore] = useState(0);

  useEffect(() => {
  const fetchDepartments = async () => {
    try {
      const response = await get_department_info_API([institute]);
      console.log("Fetched departments:", response);
      setDepartment(response);
    } catch (error) {
      console.error("Error fetching department info:", error);
    }
  };

  if (institute) {
    fetchDepartments();
  }
}, [institute]);




  useEffect(() => {
    if (triggerFetch) {
      fetchCollege();
      fetchDepartment();
      fetchCompanies();
      setTriggerFetch(false); // Reset the trigger after fetching
    }
  }, [triggerFetch]);


  useEffect(() => {
    if (role === "Training admin") {
      fetchAptitudeCount();
      fetchTechnicalCount();
      fetchTotalRequestCount();
      aptitudeAvgScore();
      getCodingAvgCore();
      getCollegeTopper();
       fetchAnnouncements();
        fetchcmpyCount();
      fetchcommunCount();
    } else if (role === "Placement admin") {
      fetchCompanyuniqueCount();
      fetchcollegeRegisteredCount();
      fetchcollegeOffer();
      fetchTotalRequestCount();
      fetchOfferChart();
      getUpcomming();
      getOfferStatus();
      fetchTotalITCount();
      fetchTotalCoreCount();
      fetchAnnouncementsPlace();

    }
  }, [role, collegeId, selectedDate, deptID, cmpyID]);
  
  
  
    const fetchTotalITCount = async () => {
      try {
        const response = await getClgTotal_IT_Count_API(collegeId); // Await the promise
        console.log("response of college registered count: ", response);
        setIT(response.job_count);
      } catch (err) {
        console.log(err.message);
      }
    };
  
    const fetchTotalCoreCount = async () => {
      try {
        const response = await getClgTotal_Core_Count_API(collegeId); // Await the promise
        console.log("response of college registered count: ", response);
        setCore(response.job_count);
      } catch (err) {
        console.log(err.message);
      }
    };
  
  

  const fetchCollege = async () => {
    try {
      const response = await getcollegeApi(); // Await the promise
      console.log("College: ", response);
      setCollege(response); // Access data directly
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchDepartment = async () => {
    try {
      const response = await getdepartmentApi(); // Await the promise
      console.log("Departments: ", response);
      setDepartment(response); // Access data directly
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await getUniqueCmpy_cc_API(collegeId); // Await the promise
      console.log("Companies: ", response);
      setCompanies(response); // Access data directly
    } catch (err) {
      console.log(err.message);
    }
  };
 const fetchAnnouncements = () => {
    getNewUpdates_cc_API(role, collegeId)
      .then((data) => {
        setAnnouncements(data);
      })
      .catch((error) => console.error("Error fetching announcements:", error));
  };

  const fetchAnnouncementsPlace = () => {
    getNewUpdates_cc_API(role, collegeId)
      .then((data) => {
        setAnnouncementsPlace(data);
      })
      .catch((error) => console.error("Error fetching announcements:", error));
  };
  //-----------------Total Aptitude, Technical Count------------------------//

  const fetchAptitudeCount = async () => {
    try {
      const response = await getAptitudeTotalCount_API(collegeId);
      console.log("total Aptitude count: ", response);
      setTotalAptitudeCount(response.count);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchTechnicalCount = async () => {
    try {
      const response = await getTechnicalTotalCount_API(collegeId); // Await the promise
      console.log("response of total technical count: ", response);
      setTotalTechicalCount(response.count); // Access data directly
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchTotalRequestCount = async () => {
    try {
      const response = await getRequestCount_CC_API(collegeId, role); // Await the promise
      console.log("totalRequest count: ", response);
      setTotalRequest(response.request_count); // Access data directly
    } catch (err) {
      console.log(err.message);
    }
  };

  const aptitudeAvgScore = async () => {
    try {
      const response = await getAvgAptitude_cc_API(collegeId, selectedDate);
      console.log("Avg score of Department: ", response);
      setAvgAptitudeScore(response);
    } catch (err) {
      console.log(err.message);
    }
  };

  const getCodingAvgCore = async () => {
    try {
      console.log("coding avg entering........");
      const response = await getAvgCoding_cc_API(collegeId, selectedDate);
      console.log("Coding Avg score of Department: ", response);
      setAvgCodingScore(response);
    } catch (err) {
      console.log(err.message);
    }
  };

  const getCollegeTopper = () => {
    if (selectedOptionClgTop === "MCQ Test") {
      getClgTopper_MCQ_CC_API(collegeId, selectedOptionClgTop)
        .then((data) => {
          setClgTopper(data);
        })
        .catch((error) =>
          console.error("Error fetching getting College Topper:", error)
        );
    }
    else if (selectedOptionClgTop === "Coding Test") {
      getClgTopper_MCQ_CC_API(collegeId, selectedOptionClgTop)
        .then((data) => {
          // console.log('Coding toper: ', data);
          setClgTopperCode(data);
        })
        .catch((error) =>
          console.error("Error fetching getting College Topper:", error)
        );
    }
  };

 const fetchOfferChart = () => {
    getOfferChart_cc_API(collegeId)
      .then((data) => {
        console.log("response", data);

        const totalOffers = data.reduce(
          (acc, item) => acc + item.number_of_offers,
          0
        );
        const itOffers = data.reduce((acc, item) => acc + item.it_of_offers, 0);
        const coreOffers = data.reduce(
          (acc, item) => acc + item.core_of_offers,
          0
        );
        const otherCount = data.filter(
          (item) => item.number_of_offers === 0
        ).length;

        console.log("total", totalOffers);
        console.log("it", itOffers);
        console.log("core", coreOffers);
        console.log("others count", otherCount);

        const assessmentData = [
          {
            type: "IT Offers",
            percentage: Number(((itOffers / totalOffers) * 100).toFixed(2)),
            color: "blue",
          },
          {
            type: "Core Offers",
            percentage: Number(((coreOffers / totalOffers) * 100).toFixed(2)),
            color: "green",
          },
        ];


        const otherOffers = totalOffers - itOffers - coreOffers;
        const otherPercentage = otherOffers > 0 ? Number(((otherOffers / totalOffers) * 100).toFixed(2)) : 0;


        if (otherCount > 0) {
          assessmentData.push({
            type: "Others",
            percentage: otherPercentage,
            color: "grey",
          });
        }

        setAssessmentData1(assessmentData);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };
  const fetchcmpyCount = async () => {
    try {
      const response = await getcompanyTotalCount_API(collegeId);
      //console.log("total Aptitude count: ", response);
      //console.log("userrole", userRole)
      setTotalcmpyCount(response.count);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchcommunCount = async () => {
    try {
      const response = await getcommunTotalCount_API(collegeId); // Await the promise
      //console.log("response of total technical count: ", response);
      setTotalcommunCount(response.count); // Access data directly
    } catch (err) {
      console.log(err.message);
    }
  };
  const getUpcomming = () => {
    getUpcomingInterview_cc_API(collegeId, deptID)
      .then((data) => {
        setUpcomming(data);
        console.log("upcomming interview: ", data);
      })
      .catch((error) =>
        console.error("Error fetching getting upcomming interview:", error)
      );
  };

  const getOfferStatus = () => {
    getOfferStatus_cc_API(collegeId, cmpyID)
      .then((data) => {
        setOfferStatus(data);
        console.log("offer Status: ", data);
      })
      .catch((error) =>
        console.error("Error fetching getting upcomming interview:", error)
      );
  };

  const fetchCompanyuniqueCount = async () => {
    try {
      const response = await getUniqueCmpy_Count_cc_API(collegeId); // Await the promise
      console.log("response of total test count: ", response);
      setTotalCompanyCount(response.unique_company_count);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchcollegeRegisteredCount = async () => {
    try {
      const response = await getClgRegistered_API(collegeId); // Await the promise
      console.log("response of college registered count: ", response);
      setRegistered(response.college_accepted_count);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchcollegeOffer = async () => {
    try {
      const response = await getJobOffer_Count_CC_API(collegeId); // Await the promise
      console.log("response of total test count: ", response);
      setTotOffers(response.job_offer_count); // Access data directly
    } catch (err) {
      console.log(err.message);
    }
  };

  //-------------------------------------------------------------------//

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        titleColor: "#ACBFD2",
        bodyColor: "#ACBFD2",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ACBFD2",
        },
        title: {
          display: true,
          color: "#ACBFD2",
        },
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          color: "#ACBFD2",
          stepSize: 10,
          callback: function (value) {
            if (value % 10 === 0) {
              return value;
            }
          },
        },
        title: {
          display: true,
          color: "#ACBFD2",
        },
      },
    },
  };

  const pieChartRef = useRef(null);

  useEffect(() => {
    if (pieChartRef.current) {
      const pieChart = new Chart(pieChartRef.current, {
        type: "doughnut",
        data: {
          labels: assessmentData1.map((data) => data.type),
          datasets: [
            {
              data: assessmentData1.map((data) => data.percentage),
              backgroundColor: assessmentData1.map((data) => data.color),
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: "top",
              labels: {
                color: "rgb(157, 190, 210", // Set legend text color to rgb(157, 190, 210
              },
            },
            tooltip: {
              callbacks: {
                label: (tooltipItem) =>
                  `${tooltipItem.label}: ${tooltipItem.raw}%`,
              },
            },
          },
          cutout: "50%",
        },
      });
      return () => {
        pieChart.destroy();
      };
    }
  }, [assessmentData1]);

  

  // dropdown
  const options = [
    { label: "Training", value: "Training admin" },
    { label: "Placement", value: "Placement admin" },
  ];

  const chartDataAvgAptitude = {
    labels: avgAptitudeScore.map((data) => data.department_name),
    datasets: [
      {
        data: avgAptitudeScore.map((data) => data.avg_score || 0),
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.4)",
        fill: false,
        tension: 0.4,
      },
    ],
  };

  const renderChartAvgAptitudeScore = () => {
    if (chartType === "Pie") {
      return (
        <div
          style={{
            width: "220px", // Set fixed width
            height: "220px", // Set fixed height
            margin: "0 auto", // Center the chart horizontally
          }}
        >
          <Pie
            data={{
              labels: avgAptitudeScore.map((data) => data.department_name),
              datasets: [
                {
                  data: avgAptitudeScore.map((data) => data.avg_score || 0),
                  backgroundColor: [
                    "rgba(75, 192, 192, 0.6)",
                    "rgba(255, 99, 132, 0.6)",
                    "rgba(54, 162, 235, 0.6)",
                    "rgba(255, 206, 86, 0.6)",
                    "rgba(153, 102, 255, 0.6)",
                    "rgba(255, 159, 64, 0.6)",
                  ],
                  borderColor: [
                    "rgba(75, 192, 192, 1)",
                    "rgba(255, 99, 132, 1)",
                    "rgba(54, 162, 235, 1)",
                    "rgba(255, 206, 86, 1)",
                    "rgba(153, 102, 255, 1)",
                    "rgba(255, 159, 64, 1)",
                  ],
                  borderWidth: 1,
                },
              ],
            }}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "top", // Position legend on the right
                  labels: {
                    usePointStyle: true, // Use a bullet point instead of a box
                    pointStyle: "circle", // Style the bullet as a circle
                    boxWidth: 5, // Decrease the size of the point/bullet
                    font: {
                      size: 8, // Decrease the font size of the labels
                    },
                    color: "white",
                    padding: 10, // Add padding between the labels
                  },
                },
                tooltip: {
                  enabled: true, // Enable tooltips for interactivity
                },
              },
              layout: {
                padding: {
                  left: 10, // Add some padding to avoid crowding
                  right: 10,
                },
              },
              scales: {
                x: {
                  display: false, // Disable the x-axis
                },
                y: {
                  display: false, // Disable the y-axis
                },
              },
            }}
          />
        </div>
      );
    } else if (chartType === "Bar") {
      return <Bar data={chartDataAvgAptitude} options={chartOptions} />;
    } else {
      return <Line data={chartDataAvgAptitude} options={chartOptions} />;
    }
  };

  const chartDataAvgCoding = {
    labels: avgCodingScore.map((data) => data.department_name),
    datasets: [
      {
        data: avgCodingScore.map((data) => data.avg_score || 0),
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.4)",
        fill: false,
        tension: 0.4,
      },
    ],
  };

  const renderChartAvgCodingScore = () => {
    if (chartType === "Pie") {
      return (
        <div
          style={{
            width: "220px", // Set fixed width
            height: "220px", // Set fixed height
            margin: "0 auto", // Center the chart horizontally
          }}
        >
          <Pie
            data={{
              labels: avgCodingScore.map((data) => data.department_name),
              datasets: [
                {
                  data: avgCodingScore.map((data) => data.avg_score || 0),
                  backgroundColor: [
                    "rgba(75, 192, 192, 0.6)",
                    "rgba(255, 99, 132, 0.6)",
                    "rgba(54, 162, 235, 0.6)",
                    "rgba(255, 206, 86, 0.6)",
                    "rgba(153, 102, 255, 0.6)",
                    "rgba(255, 159, 64, 0.6)",
                  ],
                  borderColor: [
                    "rgba(75, 192, 192, 1)",
                    "rgba(255, 99, 132, 1)",
                    "rgba(54, 162, 235, 1)",
                    "rgba(255, 206, 86, 1)",
                    "rgba(153, 102, 255, 1)",
                    "rgba(255, 159, 64, 1)",
                  ],
                  borderWidth: 1,
                },
              ],
            }}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "top", // Position legend on the right
                  labels: {
                    usePointStyle: true, // Use a bullet point instead of a box
                    pointStyle: "circle", // Style the bullet as a circle
                    boxWidth: 5, // Decrease the size of the point/bullet
                    font: {
                      size: 8, // Decrease the font size of the labels
                    },
                    color: "white",
                    padding: 10, // Add padding between the labels
                  },
                },
                tooltip: {
                  enabled: true, // Enable tooltips for interactivity
                },
              },
              layout: {
                padding: {
                  left: 10, // Add some padding to avoid crowding
                  right: 10,
                },
              },
              scales: {
                x: {
                  display: false, // Disable the x-axis
                },
                y: {
                  display: false, // Disable the y-axis
                },
              },
            }}
          />
        </div>
      );
    } else if (chartType === "Bar") {
      return <Bar data={chartDataAvgCoding} options={chartOptions} />;
    } else {
      return <Line data={chartDataAvgCoding} options={chartOptions} />;
    }
  };
  const navigate = useNavigate();
  const handleCardClickTotalAptitudeTest = (collegeId) => {
    if (!collegeId) {
      console.warn("No valid collegeId selected, defaulting to 'all'");
      collegeId = "all"; // Fallback to 'all'
    }

    console.log("Navigating with collegeId:", collegeId);
    navigate(`/total-aptitude-test-report/${String(collegeId)}`);
  };


  const handleCardClickTotalTechnicalTest = (collegeId) => {
    if (!collegeId) {
      console.warn("No valid collegeId selected, defaulting to 'all'");
      collegeId = "all"; // Fallback to 'all'
    }

    console.log("Navigating with collegeId:", collegeId);
    navigate(`/total-technical-test-report/${String(collegeId)}`);

  };
  const chartDataOfferStatus = {
    labels: assessmentData1.map((data) => data.type),
    datasets: [
      {
        data: assessmentData1.map((data) => data.percentage || 0),
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.4)",
        fill: false,
        tension: 0.4,
      },
    ],
  };

  const handleCardClickTotalRequest = (collegeId) => {
    if (!collegeId) {
      console.warn("No valid collegeId selected, defaulting to 'all'");
      collegeId = "all"; // Fallback to 'all'
    }

    console.log("Navigating with collegeId:", collegeId);
    navigate(`/total-request/${String(collegeId)}`);

  };
 const handleCardClickTotalCommunTest = (collegeId) => {
    if (!collegeId) {
      console.warn("No valid collegeId selected, defaulting to 'all'");
      collegeId = "all"; // Fallback to 'all'
    }

    console.log("Navigating with collegeId:", collegeId);
    navigate(`/total-commun-test-report/${String(collegeId)}`);
  };
 const handleCardClickTotalCompanyTest = (collegeId) => {
    if (!collegeId) {
      console.warn("No valid collegeId selected, defaulting to 'all'");
      collegeId = "all"; // Fallback to 'all'
    }

    console.log("Navigating with collegeId:", collegeId);
    navigate(`/total-company-test-report/${String(collegeId)}`);
  };
  const renderChartOfferStatus = () => {
    if (chartTypePlace === "Pie") {
      return (
        <div
          style={{
            width: "220px", // Set fixed width
            height: "220px", // Set fixed height
            margin: "0 auto", // Center the chart horizontally
          }}
        >
          <Pie
            data={{
              labels: assessmentData1.map((data) => data.type),
              datasets: [
                {
                  data: assessmentData1.map((data) => data.percentage || 0),
                  backgroundColor: [
                    "rgba(75, 192, 192, 0.6)",
                    "rgba(255, 99, 132, 0.6)",
                    "rgba(54, 162, 235, 0.6)",
                    "rgba(255, 206, 86, 0.6)",
                    "rgba(153, 102, 255, 0.6)",
                    "rgba(255, 159, 64, 0.6)",
                  ],
                  borderColor: [
                    "rgba(75, 192, 192, 1)",
                    "rgba(255, 99, 132, 1)",
                    "rgba(54, 162, 235, 1)",
                    "rgba(255, 206, 86, 1)",
                    "rgba(153, 102, 255, 1)",
                    "rgba(255, 159, 64, 1)",
                  ],
                  borderWidth: 1,
                },
              ],
            }}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "top", // Position legend on the right
                  labels: {
                    usePointStyle: true, // Use a bullet point instead of a box
                    pointStyle: "circle", // Style the bullet as a circle
                    boxWidth: 5, // Decrease the size of the point/bullet
                    font: {
                      size: 8, // Decrease the font size of the labels
                    },
                    color: "white",
                    padding: 10, // Add padding between the labels
                  },
                },
                tooltip: {
                  enabled: true, // Enable tooltips for interactivity
                },
              },
              layout: {
                padding: {
                  left: 10, // Add some padding to avoid crowding
                  right: 10,
                },
              },
              scales: {
                x: {
                  display: false, // Disable the x-axis
                },
                y: {
                  display: false, // Disable the y-axis
                },
              },
            }}
          />
        </div>
      );
    } else if (chartTypePlace === "Bar") {
      return <Bar data={chartDataOfferStatus} options={chartOptions} />;
    } else {
      return <Line data={chartDataOfferStatus} options={chartOptions} />;
    }
  };


  return (
    <div
      className="App-placement"
      style={{ backgroundColor: "#323B44", color: "#ACBFD2" }}
    >
      
      <div
        style={{
          width: "50%",
          marginLeft: "25%",
        }}
      >
        <p style={{height:"30px"}}></p>
        <div className="dropdown-officer">
          <Autocomplete
            disableClearable
            options={options}
            getOptionLabel={(option) => option.label}
            componentsProps={{
              paper: {
                sx: {
                  backgroundColor: "#4a545f",
                  color: "rgb(157, 190, 210)",
                  borderRadius: "20px",
                  border: "1px solid #3e4954",
                },
              },
              popper: {
                sx: {
                  "& .MuiAutocomplete-listbox": {
                    backgroundColor: "#323B44 !important", // Background for listbox (dropdown options)
                  },
                  "& .MuiAutocomplete-option": {
                    backgroundColor: "#323B44 !important", // Background color for each option
                    "&:hover": {
                      backgroundColor: "#323B44 !important", // Background color on hover
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#323B44", // Change the dropdown arrow color to white
                    },
                  },
                },
              },
            }}
            value={options.find((option) => option.value === role) || null}
            onChange={(event, newValue) => {
              setRole(newValue ? newValue.value : "");
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select role"
                variant="outlined"
                inputProps={{
                  ...params.inputProps,
                  readOnly: true,
                }}
              />
            )}
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "rgb(157, 190, 210)",
                fontWeight: "bold",
                backgroundColor: "#3e4954",
                borderRadius: "40px",
                padding: "10px",
                "& fieldset": {
                  border: "10px solid #18c4bb",
                  color: " rgb(157, 190, 210)",
                },
                "& .MuiSvgIcon-root": {
                  color: "white", // Change the dropdown arrow color to white
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                borderRadius: "40px",
              },
              "& .MuiInputBase-input": {
                color: "white",
              },
              "& .MuiAutocomplete-option": {
                color: "rgb(157, 190, 210)",
                backgroundColor: "#3e4954",
              },
            }}
          />
        </div>
      </div>

      <p></p>
      {/* Conditional rendering based on the role */}
      {role === "Training admin" && (
        <div>
          <section className="card-list-place">
            <div className="placement-officer-drp"  onClick={() => handleCardClickTotalCompanyTest(collegeId)}>
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-test-count">
                    <div className="card-content-wrapper">
                      <p className="card-content-off">
                        {" "}
                        {totalComapnyCount ? totalComapnyCount : 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h6 className="card-title-placedrop">CompanySpecific</h6>
            </div>
            <div className="placement-officer-drp"   onClick={() => handleCardClickTotalCommunTest(collegeId)} >
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-test-count">
                    <div className="card-content-wrapper">
                      <p className="card-content-off">
                        {" "}
                        {totalcommunCount ? totalcommunCount : 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h6 className="card-title-placedrop">Communication Test</h6>
            </div>

            <div className="placement-officer-drp"    onClick={() => handleCardClickTotalAptitudeTest(collegeId)} style={{ cursor: 'pointer' }}>
            
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-companies">
                    <div className="card-content-wrapper">
                      <p className="card-content-off">
                        {totalAptitudeCount ? totalAptitudeCount : 0}
                      </p>
                    </div>{" "}
                  </div>
                </div>
              </div>
              <h2 className="card-title-placedrop">Aptitude Test</h2>
            </div>

            <div className="placement-officer-drp" onClick={() => handleCardClickTotalTechnicalTest(collegeId)} style={{ cursor: 'pointer' }}>
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-offers">
                    <div className="card-content-wrapper">
                      <p className="card-content-pla">
                        {" "}
                        {totalTechnicalCount ? totalTechnicalCount : 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h2 className="card-title-placeoffrequ">Technical Test</h2>
            </div>

            <div className="placement-officer-drp" onClick={() => handleCardClickTotalRequest(collegeId)}>
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-requests">
                    <div className="card-content-wrapper">
                      <p className="card-content-pla">
                        {totalRequest ? totalRequest : 0}
                      </p>
                    </div>{" "}
                  </div>
                </div>
              </div>
              <h2 className="card-title-placeoffrequ">Requests</h2>
            </div>

            <p style={{ height: "40px" }}></p>

            <Container className="container-dash">
              <Row className="my-row">
                <Col className="border p-3 department-attendance col-department-attendance">
                  <div className="test test-report">
                    <h6
                      className="h6-bold-report-place"
                      style={{ color: "#fff" }}
                    >
                      TEST REPORT
                    </h6>

                    
                    <div className="date-picker-wrapper">
                      <DatePicker
                        style={{ color: "white" }}
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        dateFormat="dd-MMM-yyyy"
                        className="input-date-report"
                      />
                    </div>
                 
                                      <div  >
  <select
    onChange={(e) => setChartType(e.target.value)}
    value={chartType}
     className="college-topper-select"
     style={{color:"white"}}
  >
    <option value="Line">Line Chart</option>
    <option value="Bar">Bar Chart</option>
    <option value="Pie">Pie Chart</option>
  </select>
</div> </div>


                  <div className="score-charts">
                    <div className="chart-wrapper">
                      <p className="chart-title" style={{ color: "white" }}>
                        Avg Score-Aptitude
                      </p>
                      <div className="chart-container">
                        {renderChartAvgAptitudeScore()}
                      </div>
                    </div>

                    <div className="chart-wrapper">
                      <p className="chart-title" style={{ color: "white" }}>
                        Avg Score-Coding
                      </p>
                      <div className="chart-container">
                        {renderChartAvgCodingScore()}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col className="border p-3 department-attendance col-department-attendance">
                  <div className="test test-college-topper-officer">
                    <h6
                      className="h6-bold-topper-place"
                      style={{ color: "white" }}
                    >
                      COLLEGE_TOPPER
                    </h6>
                    <select
                      onChange={(e) => setSelectedOptionClgTop(e.target.value)}
                      value={selectedOptionClgTop}
                      className="college-topper-select"
                      style={{ color: "white" }}
                    >
                      <option value="MCQ Test">MCQ</option>
                      <option value="Coding Test">Coding</option>
                    </select>
                  </div>

                  {selectedOptionClgTop === "MCQ Test" && (
                    <table className="table college-topper-table">
                      <thead>
                        <tr>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Name
                          </th>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Department
                          </th>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Score
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {clgTopper.length === 0 ? (
                          <tr>
                            <td
                              colSpan={4} // Span all columns
                              style={{
                                color: "#ffff",
                                backgroundColor: "#3e4954",
                                textAlign: "center", // Center align text
                              }}
                              className="table-cell"
                            >
                              Data not found
                            </td>
                          </tr>
                        ) : (
                          clgTopper.map((item, index) => (
                            <tr key={item.id || index}>
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.student_name}
                              </td>
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.department}
                              </td>
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                               {item.avg_mark}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  )}

                  {selectedOptionClgTop === "Coding Test" && (
                    <table className="table college-topper-table">
                      <thead>
                        <tr>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Name
                          </th>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Department
                          </th>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Score
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {clgTopper.length === 0 ? (
                          <tr>
                            <td
                              colSpan={4} // Span all columns
                              style={{
                                color: "#ffff",
                                backgroundColor: "#3e4954",
                                textAlign: "center", // Center align text
                              }}
                              className="table-cell"
                            >
                              Data not found
                            </td>
                          </tr>
                        ) : (
                          clgTopperCode.map((item, index) => (
                            <tr key={item.id || index}>
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.student_name}
                              </td>
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.department}
                              </td>
                             <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.avg_mark}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  )}

                  <div />
                </Col>
              </Row>
            </Container>

            <div className="container-place-dash">
              <div className="row-place">
                <div className="col-dashboard">
                  <div className="test2">
                    <h6 className="h6-bold" style={{ color: "white" }}>
                      Trainer Details
                    </h6>
                  </div>
                  <div className="table-responsive-place">
                    <table
                      className={`table-trainer-place ${
                        trainerDetails.length > 5 ? "table-scrollable" : ""
                      }`}
                    >
                      <thead>
                        <tr>
                        {/*}  <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Name
                          </th>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Skills
                          </th>*/}
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Topic
                          </th>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            Start Date
                          </th>
                          <th
                            style={{
                              fontWeight: "bold",
                              backgroundColor: "#3e4954",
                              color: "#fff",
                            }}
                            className="table-header"
                          >
                            End Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {trainerDetails.length === 0 ? (
                          <tr>
                            <td
                              colSpan={4} // Span all columns
                              style={{
                                color: "#ffff",
                                backgroundColor: "#3e4954",
                                textAlign: "center", // Center align text
                              }}
                              className="table-cell"
                            >
                              Data not found
                            </td>
                          </tr>
                        ) : (
                          trainerDetails.map((item) => (
                            <tr key={item.id}>
                             {/*} <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.trainer_name}
                              </td>
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.trainer_skills}
                              </td>*/}
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.topic}
                              </td>
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.dtm_start_trainer}
                              </td>
                              <td
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#3e4954",
                                }}
                                className="table-cell"
                              >
                                {item.dtm_end_trainer}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-dashboard">
                  <div className="test2">
                    <h6 className="h6-bold" style={{ color: "white" }}>
                      Test Details
                    </h6>
                  </div>
                  <div className="table-responsive-place">
                    <table
                      className={`table-test-place ${
                        trainerDetails.length > 5 ? "table-scrollable" : ""
                      }`}
                    >
                      <thead>
                              <tr>
                               {/*} <th
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#3e4954",
                                    color: "white",
                                  }}
                                  className="table-header"
                                >
                                  College
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#3e4954",
                                    color: "white",
                                  }}
                                  className="table-header"
                                >
                                  Department
                                </th>*/}
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#3e4954",
                                    color: "white",
                                    width:"auto",
                                  }}
                                  className="table-header"
                                >
                                  TestName
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#3e4954",
                                    color: "white",
                                    whiteSpace: "nowrap",
                                  }}
                                  className="table-header"
                                >
                                  Test Date
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#3e4954",
                                    color: "white",
                                    width:"100px"
                                  }}
                                  className="table-header"
                                >
                                Assigned
                                </th>
                                <th
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#3e4954",
                                    color: "#fff",
                                    width:"100px"
                                  }}
                                  className="table-header"
                                >
                                 Attended
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {testDetails.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={4} // Span all columns
                                    style={{
                                      color: "#ffff",
                                      backgroundColor: "#3e4954",
                                      textAlign: "center", // Center align text
                                    }}
                                    className="table-cell"
                                  >
                                    Data not found
                                  </td>
                                </tr>
                              ) : (
                                testDetails.map((item) => (
                                  <tr key={item.id}>
                                   {/*} <td
                                      style={{
                                        color: "#fff",
                                        backgroundColor: "#3e4954",
                                      }}
                                      className="table-cell"
                                    >
                                      {item.college}
                                    </td>
                                    <td
                                      style={{
                                        color: "#fff",
                                        backgroundColor: "#3e4954",
                                      }}
                                      className="table-cell"
                                    >
                                      {item.department}
                                    </td>*/}
                                    <td
                                      style={{
                                        color: "#fff",
                                        backgroundColor: "#3e4954",
                                        width:"auto"
                                      }}
                                      className="table-cell"
                                    >
                                      {item.test_name}
                                    </td>
                                    <td
                                      style={{
                                        color: "#fff",
                                        backgroundColor: "#3e4954",
                                      }}
                                      className="table-cell"
                                    >
                                      {item.dtm_start}
                                    </td>
                                    <td
                                      style={{
                                        color: "#fff",
                                        backgroundColor: "#3e4954",
                                        width:"100px"
                                      }}
                                      className="table-cell"
                                    >
                                      {item.student_count}
                                    </td>
                                    <td
                                      style={{
                                        color: "#fff",
                                        backgroundColor: "#3e4954",
                                        width:"100px"
                                      }}
                                      className="table-cell"
                                    >
                                      {item.active_student_count}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="news-updates-training">
            <div className="news-updates-header">
              <h6 className="h6-bold-news-place">NEWS UPDATES</h6>
            </div>

            <div className="table-responsive-dash">
              {announcements.length > 0 ? (
                <div
                  className={`table-test ${
                    announcements.length > 1 ? "table-scrollable" : ""
                  }`}
                >
                  {announcements.map((announcement, index) => (
                    <div key={index} className="announcement-item">
                      <p className="news-head">{announcement.announcement}</p>
                      {announcement.announcement_image && (
                        <img
                          className="news-img"
                          src={`data:image/png;base64,${announcement.announcement_image}`}
                          alt="Announcement"
                          width={80}
                          height={80}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p>No announcements available.</p>
              )}
            </div>
          </div>
        </div>
      )}

      {role === "Placement admin" && (
        <div>
           <section className="card-list-place">
            <div className="placement-officer-drp">
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-test-count">
                    <div className="card-content-wrapper">
                      <p className="card-content-off">
                       {" "}
                        {totalComapnyCount ? totalComapnyCount : 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h6 className="card-title-placedrop">Total Companies</h6>
            </div>

            <div className="placement-officer-drp">
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-companies">
                    <div className="card-content-wrapper">
                      <p className="card-content-off">
           
                      {totOffers ? totOffers : 0}
                      </p>
                    </div>{" "}
                  </div>
                </div>
              </div>
              <h2 className="card-title-placedrop">Total Offers</h2>
            </div>

            <div className="placement-officer-drp">
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-companies">
                    <div className="card-content-wrapper">
                      <p className="card-content-off">
                      {it ? it : 0}
                        {" "}
                        
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h2 className="card-title-placedrop">IT Offers</h2>
            </div>

            <div className="placement-officer-drp">
              <div className="card-container-placedrop">
                <div className="square-container-placedrop">
                  <div className="card-lms card-offers">
                    <div className="card-content-wrapper">
                      <p className="card-content-pla">
                      {core ? core : 0}
                      </p>
                    </div>{" "}
                  </div>
                </div>
              </div>
              <h2 className="card-title-placeoffrequ">Core Offers</h2>
            </div>
            <div className="container-placement">
              <div className="row">
                <div className="col-dashboard">
                  <h6 className="h6-bold" style={{ color: "white" }}>
                    OFFER CHART
                  </h6>

                  <div className="pie-chart-container">
                    {renderChartOfferStatus()}
                  </div>
                </div>
                <div className="col-dashboard">
                  <div className="test2">
                    <h6
                      className="h6-bold-interview-place"
                      style={{ color: "white" }}
                    >
                      UPCOMING INTERVIEW
                    </h6>

                 <select
  className="dropdown-custom-dash"
  onChange={(e) => setDeptID(e.target.value)}
  value={deptID}
  style={{ color: "white" }}
>
  <option value="">All</option>
  {department.map((item) => (
    <option key={item.department_id_value} value={item.department_id_value}>
      {item.department_name_value}
    </option>
  ))}
</select>




                  </div><p></p>
                  <div className="custom-scrollbar"
  style={{
    maxHeight: "300px",
    overflow: "auto",

}}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#3e4954",
                            color: "#fff",
                          }}
                          className="table-header"
                        >
                          Company Name
                        </th>
                        
                        <th
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#3e4954",
                            color: "#fff",
                          }}
                          className="table-header"
                        >
                          Date
                        </th>
                        <th
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#3e4954",
                            color: "#fff",
                          }}
                          className="table-header"
                        >
                          Reg
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {upcomming.length === 0 ? (
                        <tr>
                          <td
                            colSpan={4} // Span all columns
                            style={{
                              color: "#ffff",
                              backgroundColor: "#3e4954",
                              textAlign: "center", // Center align text
                            }}
                            className="table-cell"
                          >
                            Data not found
                          </td>
                        </tr>
                      ) : (
                        upcomming.map((item) => (
                          <tr key={item.id}>
                            <td
                              style={{
                                color: "#fff",
                                backgroundColor: "#3e4954",
                              }}
                              className="table-cell"
                            >
                              {item.job_id__company_name}
                            </td>
                            <td
                              style={{
                                color: "#fff",
                                backgroundColor: "#3e4954",
                              }}
                              className="table-cell"
                            >
                              {item.job_id__interview_date}
                            </td>
                            <td
                              style={{
                                color: "#fff",
                                backgroundColor: "#3e4954",
                              }}
                              className="table-cell"
                            >
                              {item.registered_count}
                            </td>
                            
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table></div>
                </div>
                <div className="col-dashboard">
                  <div className="test2">
                    <h6
                      className="h6-bold-sts1"
                      style={{
                        color: "white",
                        marginRight: "15px",
                        fontSize: "13px",
                      }}
                    >
                      OFFER STATUS
                    </h6>

                    <select
                      style={{ color: "white" }}
                       className="dropdown-custom-dash"
                      onChange={(e) => setCmpyID(e.target.value)}
                      value={cmpyID}
                    >
                      <option value="">All</option>
                      {companies.map((item, index) => (
                        <option key={index} value={item.company_name}>
                          {item.company_name}
                        </option>
                      ))}
                    </select>
                  </div><p></p>
                  <div className="custom-scrollbar"
  style={{
    maxHeight: "300px",
    overflow: "auto",

}}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#3e4954",
                            color: "#fff",
                          }}
                          className="table-header"
                        >
                          Status
                        </th>
                        <th
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#3e4954",
                            color: "#fff",
                          }}
                          className="table-header"
                        >
                          Count
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {offerStatus.length === 0 ? (
                        <tr>
                          <td
                            colSpan={4} // Span all columns
                            style={{
                              color: "#ffff",
                              backgroundColor: "#3e4954",
                              textAlign: "center", // Center align text
                            }}
                            className="table-cell"
                          >
                            Data not found
                          </td>
                        </tr>
                      ) : (
                        offerStatus.map((item) => (
                          <tr key={item.id}>
                            <td
                              style={{
                                color: "#fff",
                                backgroundColor: "#3e4954",
                              }}
                              className="table-cell"
                            >
                              {item.round_of_interview}
                            </td>
                            <td
                              style={{
                                color: "#fff",
                                backgroundColor: "#3e4954",
                              }}
                              className="table-cell"
                            >
                              {item.student_count}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table></div>
                </div>
              </div>
            </div>
          </section>

          <div className="news-updates-training">
            <div className="news-updates-header">
              <h6 className="h6-bold-news-place">NEWS UPDATES</h6>
            </div>

            <div className="table-responsive-dash">
              {announcementsPlace.length > 0 ? (
                <div
                  className={`table-test ${
                    announcementsPlace.length > 5 ? "table-scrollable" : ""
                  }`}
                >
                  {announcementsPlace.map((announcement, index) => (
                    <div key={index} className="announcement-item">
                      {/* Display the current announcement */}
                      <p className="news-head">{announcement.announcement}</p>
                      {announcement.announcement_image && (
                        <img
                          className="news-img"
                          src={`data:image/png;base64,${announcement.announcement_image}`}
                          alt="Announcement"
                          width={80}
                          height={80}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p>No announcements available.</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
